var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"hierarchy-item",on:{"click":function($event){return _vm.selectItem()}}},[_c('div',{staticClass:"hierarchy-title",attrs:{"title":_vm.item.question},domProps:{"innerHTML":_vm._s('Item: ' + _vm.truncatedTitle())}})])}
var staticRenderFns = []

export { render, staticRenderFns }